import { Props as StoreblocksSelectProps } from "@storeblocks/select";
import {
  mapNumericOptionToStringOptiton,
  mapStringOptionToNumericOption,
} from "./selectUtils";
import {
  StyledSelectDiv,
  StyledSpinnerDiv,
  StyledStoreblocksSelect,
} from "./styled";

import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { useField } from "formik";
import React from "react";
import { SelectOptionProps } from "./selectTypes";

type Props = Omit<StoreblocksSelectProps, "onChange" | "value" | "options"> &
  SelectOptionProps & {
    name: string;
    isLoading?: boolean;
  };

export const Select = ({
  disabled,
  error,
  fluid,
  hint,
  id,
  label,
  large,
  medium,
  name,
  onBlur,
  onChange,
  options,
  placeholder,
  small,
  isLoading,
  numeric,
  hintProps,
  labelPopoverProps,
}: Props): React.ReactElement => {
  const [field, { touched }, helpers] = useField(name);

  return (
    <StyledSelectDiv>
      <StyledStoreblocksSelect
        {...field}
        onBlur={(event) => {
          field.onBlur(event);
          onBlur?.(event);
        }}
        disabled={disabled}
        error={error && touched ? error : undefined}
        fluid={fluid}
        id={id}
        hint={hint}
        label={label}
        onChange={async (event, option) => {
          if (numeric) {
            const numericOption = mapStringOptionToNumericOption(option);
            await helpers.setValue(numericOption.value);
            await helpers.setTouched(true);
            onChange?.(numericOption);
          } else {
            await helpers.setValue(event.target.value);
            await helpers.setTouched(true);
            onChange?.(event, option);
          }
        }}
        value={field.value}
        large={large}
        medium={medium}
        options={
          numeric ? options.map(mapNumericOptionToStringOptiton) : options
        }
        small={small}
        placeholder={placeholder}
        hintProps={hintProps}
        labelPopoverProps={labelPopoverProps}
      />
      {isLoading && (
        <StyledSpinnerDiv>
          <ThemedSpinner />
        </StyledSpinnerDiv>
      )}
    </StyledSelectDiv>
  );
};
